<template>
    <div class="actions-cell">
        <!-- Primary Action: View Profile -->        
        <!-- Secondary Actions: More Dropdown -->
        <b-dropdown
            v-if="hasSecondaryActions"
            variant="link"
            size="sm"
            no-caret
            toggle-class="action-btn-more"
            right
            :disabled="busy"
            aria-label="More actions"
            @shown="dropdownShown = true"
            @hidden="dropdownShown = false"
        >
            <template #button-content>
                <span class="more-dots" aria-hidden="true">⋯</span>
                <span class="sr-only">More actions</span>
            </template>
            
            <b-dropdown-item
                @click="handleViewProfile"
                aria-label="View Profile"
            >
                <i class="icon-eye-view mr-2"></i>
                View Profile
            </b-dropdown-item>
            <!-- <b-dropdown-item
                v-if="isSubmitted"
                @click="handleShowProgress"
                aria-label="View Progress"
            >
                <i class="icon-eforms mr-2"></i>
                Progress
            </b-dropdown-item> -->
            
            <b-dropdown-item
                v-if="isSubmitted"
                @click="handleResendInvite"
                aria-label="Resend Invite"
            >
                <i class="icon-edit mr-2"></i>
                Resend Invite
            </b-dropdown-item>
        </b-dropdown>
    </div>
</template>

<script>
export default {
    name: 'BaseStatusV2',
    
    props: {
        record: {
            type: Object,
            required: true,
        },
        permissions: {
            type: [Object, Array],
            default: null,
        },
        busy: {
            type: Boolean,
            default: false,
        },
    },
    
    data() {
        return {
            dropdownShown: false,
        }
    },
    
    computed: {
        isSubmitted() {
            // Hide Resend Invite if status is 'Submitted'
            return this.record.status !== 'Submitted'
        },
        
        hasSecondaryActions() {
            // Show dropdown if we have at least Progress or Resend Invite
            return true // Always show Progress at minimum
        },
    },
    
    methods: {
        handleViewProfile() {
            if (this.busy) return
            this.$emit('view-profile', this.record)
        },
        
        handleShowProgress() {
            if (this.busy) return
            this.$emit('show-progress', this.record)
        },
        
        handleResendInvite() {
            if (this.busy) return
            this.$emit('resend-invite', this.record)
        },
    },
}
</script>

<style scoped>
/* Actions Cell Styles */
.actions-cell {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-wrap: nowrap;
    justify-content: flex-start;
}

.action-btn-primary {
    white-space: nowrap;
    min-width: auto;
}

.action-btn-more {
    padding: 0.25rem 0.5rem !important;
    color: #6c757d !important;
    text-decoration: none !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    border: none !important;
    background: transparent !important;
    font-size: 1.25rem !important;
    line-height: 1 !important;
    min-width: 2rem !important;
    height: 2rem !important;
    box-shadow: none !important;
}

.action-btn-more:hover,
.action-btn-more:focus {
    color: #495057 !important;
    background-color: #f8f9fa !important;
    border-radius: 0.25rem !important;
    outline: 2px solid #007bff !important;
    outline-offset: 2px !important;
    box-shadow: none !important;
}

.action-btn-more:focus:not(:focus-visible) {
    outline: none !important;
}

.action-btn-more:active {
    background-color: #e9ecef !important;
    box-shadow: none !important;
}

.more-dots {
    display: inline-block;
    font-size: 1.5rem;
    line-height: 1;
    font-weight: bold;
    color: inherit;
    transform: rotate(90deg);
}

/* Responsive: Mobile - Compact layout, hide text if needed */
@media (max-width: 575.98px) {
    .actions-cell {
        flex-direction: row;
        gap: 0.375rem;
        align-items: center;
        flex-wrap: wrap;
        justify-content: flex-start;
    }
    
    .action-btn-primary {
        flex: 1 1 auto;
        min-width: auto;
        padding: 0.25rem 0.5rem;
    }
    
    .action-btn-primary .btn-text-desktop {
        display: none;
    }
    
    .action-btn-primary .mr-1 {
        margin-right: 0 !important;
    }
    
    .action-btn-more {
        flex: 0 0 auto;
        min-width: 2rem;
    }
}

/* Very small screens - stack vertically */
@media (max-width: 360px) {
    .actions-cell {
        flex-direction: column;
        align-items: stretch;
    }
    
    .action-btn-primary,
    .action-btn-more {
        width: 100%;
        justify-content: center;
    }
}

/* Tablet: Show icon + text on primary button */
@media (min-width: 576px) and (max-width: 991.98px) {
    .action-btn-primary .btn-text-desktop {
        display: inline;
    }

}

/* Desktop: Full buttons */
@media (min-width: 992px) {
    .action-btn-primary .btn-text-desktop {
        display: inline;
    }
    
    .actions-cell {
        gap: 0.5rem;
    }
}
.dropdown{
    overflow: visible !important;
}
/* Ensure dropdown items are accessible */
:deep(.dropdown-item) {
    display: flex;
    align-items: center;
    cursor: pointer;
}

:deep(.dropdown-item):focus {
    outline: 2px solid #007bff;
    outline-offset: -2px;
}

:deep(.dropdown-item i) {
    width: 1.25rem;
    text-align: center;
}
</style>




